import { BaseApi } from './base.api.js';

export class MailTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/mail-template');
    }
}
